// Generated by GitHub Copilot
import { useMemo } from 'react';
import { pgInstanceId } from './constants';

export default function useDataIsland() {
  return useMemo(() => ({
    page: {
      BIRF: {
        pg: 'syc_psx_buy', // pg or pg id
        pg_inst: pgInstanceId, // pg instance.
        pg_id: 'slp_psx_buy',
      },
      vehicle: {
        car_type: 'used',
      },
    },
  }), []);
}
